import React from 'react'
import Navbar from '../Layout/Navbar'
import Contact from './Contact'
import Youtube from './Youtube'
import Causes from './Causes'
import ShareMemory from './ShareMemory'
import CardSlider from './CardSlider'
//import TextSliderCall from './TextSliderCall'
import Footer from '../Layout/Footer'
import SecOverlay from './SecOverlay'
import FAQs from './FAQs'


function Home() {
  return (
    <>
    <Navbar />
    <SecOverlay/>
    <Contact/>
    <Youtube/>
    <FAQs/>
    <Causes/>    
    <CardSlider/>
    <ShareMemory/>
    {/* <TextSliderCall/> */}
    <Footer/>     
    </>
  )
}

export default Home